const formatCurrency = (amount, currency) => 
  `$${parseFloat(amount).toLocaleString('es-MX', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency} *`;

export default formatCurrency;